import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {VALUES_PROP_TYPE} from 'eventbrite_design_system/inputField/constants';

import {getCanonicalSearchUrl} from '@eb/destination-utils';

const _getRefinement = ({type, value}) => {
    let refinement = {};

    if (type === 'price') {
        refinement = {price: value};
    }
    if (type === 'tags' || type === 'format') {
        refinement = {tags: value};
    }
    if (type === 'dates') {
        refinement = {dates: value};
    }

    return refinement;
};

export default class FilterLinks extends PureComponent {
    static propTypes = {
        locationSlug: PropTypes.string,
        values: VALUES_PROP_TYPE,
    }

    render() {
        const {
            locationSlug,
            values,
            type,
        } = this.props;

        const component = (
            values.map(({value, display}) => {
                const refinement = _getRefinement({type, value});

                return (
                    <li key={value}>
                        <a href={getCanonicalSearchUrl({slug: locationSlug, ...refinement})}>
                            {display}
                        </a>
                    </li>
                );
            })
        );

        return (
            <ul>
                {component}
            </ul>
        );
    }
}
